import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-claro-label',
  templateUrl: './claro-label.component.html',
  styleUrls: ['./claro-label.component.scss']
})
export class ClaroLabelComponent implements OnInit {
@Input() iconPath : string = "";
@Input() colorScheme : string;
@Input() labelText: string;
@Input() height: string;
@Input() width: string;
@Input() fontSize: string;
@Input() isPaleStyle: boolean = false;

  

  constructor() { 
  }

  ngOnInit(): void {
    // console.log(`in claro label icon text is ${this.labelText}`);
    // console.log(`in CL ngOnInit iconPath is ${this.iconPath}`);
  }

}
